import { registerHandler } from "../handler";

declare const pintrk: any;

interface PinterestParams {
  planId: string;
  duration: number;
  ageRange?: string;
  age?: string;
  weight?: number;
  idealWeight?: number;
  idealWeightKg?: number;
  weightKg?: number;
  weightLossGoal?: number;
  weightLossGoalKg?: number;
}

const PINTERST_TAG_ID = "2620804621622";

/**
 * Formats a new params object for use in the conv_param1 prop of the Pinterest Pixel tag.
 * NOTE(Rose): Make sure to handle surveyAnswers or its props being undefined due to
 * inconsistencies between US/nonUS survey data (e.g. ageRange is US, age is nonUS).
 */
function getPinParams(plan, surveyAnswers) {
  const params: PinterestParams = {
    planId: plan.braintree_id,
    duration: plan.duration,
  };
  const requestedParams = [
    "ageRange",
    "age",
    "weight",
    "idealWeight",
    "weightKg",
  ];

  if (surveyAnswers) {
    requestedParams.forEach((key) => {
      if (surveyAnswers?.[key]) {
        params[key] = surveyAnswers[key];
      }
    });

    if (params.weight && params.idealWeight) {
      params.weightLossGoal = params.weight - params.idealWeight;
    } else if (params.weightKg && surveyAnswers.weightLossGoal) {
      params.weightLossGoalKg = surveyAnswers.weightLossGoal;
      params.idealWeightKg = params.weightKg - surveyAnswers.weightLossGoal;
    }
  }
  return params;
}

function convertToPinConvParam(params) {
  const convParam = [];
  Object.keys(params).forEach((key) => {
    const param = params[key];
    if (param != null && param) {
      convParam.push(`${key}:${param.toString()}`);
    }
  });
  return convParam.join(",");
}

// https://developers.pinterest.com/docs/ad-tools/conversion-tag/
export default function registerHandlers() {
  registerHandler("lead", ({ email }) => {
    // Advanced tracking for Pinterest.
    if (email) {
      pintrk("load", PINTERST_TAG_ID, {
        em: email.toLowerCase(),
      });
    }
    pintrk("track", "lead");
  });

  registerHandler("initiateCheckout", () => {
    pintrk("track", "addtocart");
  });

  registerHandler("purchase", ({ order, plan, surveyAnswers }) => {
    const convParam = convertToPinConvParam(getPinParams(plan, surveyAnswers));
    pintrk("track", "checkout", {
      value: order.erev_9_months,
      order_quantity: 1,
      currency: "USD",
      order_id: order.subscriptionId,
      conv_param1: convParam,
    });
  });
}
